import { ALLOW_VERSIONS } from 'lib/types';

const toVersion = (version: string) => (ALLOW_VERSIONS.includes(version) ? version : '3.0.0');

export default toVersion;
